import * as React from 'react'
import RedirectPage from 'redirectPage'
import barcodesReportImage from 'images/barcodes-report.png'

const EMAIL_TAB_NODE_ID = '5xCrsM0cH0'

interface EmailsReportPageProps {
    accountSlug: string
}

const EmailsReportPage = ({ accountSlug }: EmailsReportPageProps) => (
    <RedirectPage
        oldPageTitle="Emails Report"
        newPageTitle="Marketing Report"
        action="is now part of"
        image={barcodesReportImage}
        link={`/account/${accountSlug}/reports/marketing#${EMAIL_TAB_NODE_ID}`}
    />
)

export default EmailsReportPage
